<template>
    <v-container class="content-container">
        <v-card outlined class="rounded-16 pa-5">
            <v-row align="center" justify="space-between" dense class="mb-4">
                <v-col cols="auto">
                    <h5 class="text-h5 font-weight-medium">Find codes and standards</h5>
                </v-col>
                <v-col cols="auto">
                    <!-- Don't change/remove class tracking_home_link_browse_codes, using for Google analytics tracking -->
                    <a
                        :href="getRoute('codes')"
                        class="text-body-1 font-weight-medium text-decoration-underline tracking_home_link_browse_codes">
                        Browse All Codes
                        <v-icon color="primary">mdi-chevron-right</v-icon>
                    </a>
                </v-col>
            </v-row>

            <v-row dense class="category-list-buttons">
                <category-menu
                    v-for="(menu, index) in menus"
                    :key="menu.title"
                    :title="menu.title"
                    :btnClassName="menu.class"
                    :menu-groups="menu.groups"
                    :padding-left="getPadding(index, 'left')"
                    :padding-right="getPadding(index, 'right')"
                />
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import CategoryMenu from './CategoryMenu.vue';
import Mobile from '../inc/mixins/mobile';

export default {
    components: {
        CategoryMenu,
    },
    mixins: [Mobile],
    computed: {
        categories() {
            const { Category = [], Location = [] } = this.$store.getters.getSearchNavigationCategories || {};
            const all = [...Category, ...Location];
            const find = (key) => all.find(item => item.key === key)?.children || [];

            return {
                'i-codes': find('i-codes'),
                commentaries: find('commentaries'),
                resources: find('resources'),
                standards: find('standards'),
                unitedStates: find('united-states'),
                global: find('global')
            };
        },
        menus() {
            return [
                {
                    title: 'I-Codes',
                    groups: [
                        { title: 'I-Codes', slug: 'i-codes', items: this.categories['i-codes'] },
                        { title: 'Commentaries', slug: 'commentaries', items: this.categories.commentaries }
                    ],
                    class: 'tracking_home_btn_icodes'
                },
                {
                    title: 'Resources',
                    groups: [{ title: 'Resources', slug: 'resources', items: this.categories.resources }],
                    class: 'tracking_home_btn_resources'
                },
                {
                    title: 'Locations',
                    groups: [
                        { title: 'United States', slug: 'united-states', items: this.categories.unitedStates },
                        { title: 'Global', slug: 'global', items: this.categories.global }
                    ],
                    class: 'tracking_home_btn_locations'
                },
                {
                    title: 'Standards',
                    groups: [{ title: 'Standards', slug: 'standards', items: this.categories.standards }],
                    class: 'tracking_home_btn_standards'
                }
            ];
        }
    },
    methods: {
        getPadding(index, side) {
            const first = 0;
            const last = this.menus.length - 1;

            if (this.isMobilePort) return 1;

            if (side === 'left') {
                return index === first ? 1 : 3;
            }
            if (side === 'right') {
                return index === last ? 1 : 3;
            }

            return 3;
        }
    }
};
</script>

<style scoped>
.rounded-16 {
    border-radius: 16px;
}
</style>
